// src/services/adminInsightsService.js
import axios from "axios";

// ✅ Use same env key everywhere
const API_BASE = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: API_BASE,
});


// attach token if available
api.interceptors.request.use(cfg => {
  const t = localStorage.getItem("token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// fetch insights
export const getInsights = () =>
  api.get("admin/insights").then(r => r.data);

export { api }; // in case you want to reuse it
